import React, {Component} from 'react';
import { FaOilCan } from 'react-icons/fa';
import { RiPlantLine } from 'react-icons/ri';
import { BsFillDropletFill } from 'react-icons/bs';
import {Nav,Navbar,NavDropdown} from "react-bootstrap";
import {Dropdown} from 'react-bootstrap'
import TreatmentCompliance from '../../../../components/doctor/PatientsDropdown/TreatmentComplience';
import Flags from '../../../../components/doctor/PatientsDropdown/Flags';
import ClinicalGlobalImprovement from '../../../../components/doctor/PatientsDropdown/ClinicalGlobalImprovement';
import DeliverySystem from '../../../../components/doctor/PatientsDropdown/DeliverySystem';
import {withTranslation} from "react-i18next";
import {compose} from "redux";
import {connect} from "react-redux";
import AddPatient from "../../../../components/doctor/addPatient";
import SvGraphics from "../../../../assets/SvGraphics";
import doctorApi from "../../../../services/ApiServices/doctorApi";
import {setPatientsData,filterPatientsTable} from "../../../../redux/actions/Tabs-Actions";
import Switch from "react-switch";
import {FormControlLabel} from "@material-ui/core";
import {authenticationService} from "../../../../services/AuthenticationService";





class PatientsDashboardComposed extends Component{
    constructor(props) {
        super(props);
        this.state = {
            title: "name",
            view: "Delivery System",
            isSideBarOpen:false,
            patientSwitch:false,
            patients:{}
        }
    }

    async componentDidMount() {
    }


    changeView1 = () => {
        this.setState({view: 'Delivery System'});
    }

    changeView2 = () => {
        this.setState({view: 'Clinical Global Improvement'});
    }

    changeView3 = () => {
        this.setState({view: 'Treatment Compliance'});
    }

    changeView4 = () => {
        this.setState({view: 'Flags'});
    }

    openSideBar(){
        document.body.style.overflow = "hidden"
        this.setState({isSideBarOpen:true})
    }



    render() {
        let { view} = this.state
        let {t} = this.props
        let {isSideBarOpen} = this.state
        let currentUser=authenticationService.currentUserValue;
        let leumitUser =currentUser?.profile?.Leumit_clinic

        return (

            <>
                <div className={'asaya-info'}>
                    <div className={"patient-page-up-rows"}>
                        <div className={"patient-page-up-row-switch"}>
                            <div style={{marginTop:'35px'}}>
                                <FormControlLabel
                                    control={<Switch size="Small" checked={this.props.patientSwitch} onChange={()=>this.props.switchPatient()}
                                                     uncheckedIcon={false} checkedIcon={false} onColor={'#a8ae37'}/>}
                                />

                                <label className={"my-patients-label"}> {t('doctor.my_patient')}</label>
                            </div>
                        </div>


                        <div className={"patient-page-up-row"}>
                            {/*                        <label className={"patient-num-total"}>{this.props.patientsData?this.props.patientsData.length:0}</label>
                        <label className={"patient-num-total-label"}>{t('doctor.patients')}</label>*/}
                            <div>
                                <label className={"patient-num-total"}>{this.props.patientsData?this.props.patientsData.length:0}</label>
                                <label className={"patient-num-total-label"}>{t('doctor.patients')}</label>
                            </div>
                            <div className={"navbar-nav"} style={{display:'flex'}}>
                                <div className={"patient-menu-up"}>
                                    <select className={'selectBox-menu-up'} id="Gender" name="Gender">
                                        <option className={'selectBox-menu-up-options'}  value="DeliverySystem">{t('doctor.delivery_system')}</option>
                                        <option className={'selectBox-menu-up-options'} value="ClinicalGlobalImprovement">{t('doctor.clinical_global_improvement')}</option>
                                        <option className={'selectBox-menu-up-options'} value="Flags">{t('doctor.flags')}</option>
                                    </select>
                                    {
                                        view === t('doctor.delivery_system')  ?
                                            (
                                                <DeliverySystem/>
                                            )
                                            : view === t('doctor.clinical_global_improvement') ?
                                                (
                                                    <ClinicalGlobalImprovement/>
                                                )

                                                : view === t('doctor.flags') ?
                                                    (
                                                        <Flags/>
                                                    )
                                                    :<DeliverySystem/>
                                    }

                                </div>
                            </div>
                            {leumitUser!=="T" &&<div className={'addNewPatientBlock'} onClick={this.openSideBar.bind(this)}>
                                + {t('doctor.add_new_patients')}
                            </div>
                            }
                        </div>
                        <div className={"patient-page-up-row2"}>
                            <div className={"patient-page-up-clinical-data"}>
                                <div className={"patient-page-up-clinical-data-1st-block"}>
                                    <SvGraphics className={"patient-page-up-clinical-data-title-icon"}  width={'30px'} height={'30px'} svgname={'doctor-icon'}/>
                                    <label className={"patient-page-up-clinical-data-title-text-label"}>{t('doctor.clinical_data')}:
                                    </label>
                                </div>
                                <div className={"patient-page-up-clinical-data-block"}>
                                    <label className={"patient-page-up-clinical-data-num-label"}>0</label>
                                    <label className={"patient-page-up-clinical-data-text-label"}>{t('doctor.reported_improvement')}</label>
                                    <span className={"lineBetween"}/>

                                </div>
                                <div className={"patient-page-up-clinical-data-block"}>
                                    <label className={"patient-page-up-clinical-data-num-label"}>0</label>
                                    <label className={"patient-page-up-clinical-data-text-label"}>{t('doctor.reported_deterioration')}
                                    </label>
                                    <span className={"lineBetween"}/>
                                </div>
                                <div className={"patient-page-up-clinical-data-block-long"}>
                                    <label className={"patient-page-up-clinical-data-num-label"}>0</label>
                                    <label className={"patient-page-up-clinical-data-text-label-long"}>{t('doctor.significant_medications')}</label>
                                    <span className={"lineBetween"}/>
                                </div>
                                <div className={"patient-page-up-clinical-data-block"}>
                                    <label className={"patient-page-up-clinical-data-num-label"}>0</label>
                                    <label className={"patient-page-up-clinical-data-text-label"}>{t('doctor.significant_effect')}</label>
                                </div>
                            </div>
                            <div className={"patient-page-up-administrative-data"}>
                                <div className={"patient-page-up-administrative-data-1st-block"}>
                                    <SvGraphics className={"patient-page-up-administrative-data-title-icon"}  svgname={'admin-icon'}/>
                                    <label className={"patient-page-up-administrative-data-title-text-label"}>{t('doctor.administrative_data')}:
                                    </label>
                                </div>
                                <div className={"patient-page-up-administrative-data-block"}>
                                    <label className={"patient-page-up-administrative-data-num-label"}>0</label>
                                    <label className={"patient-page-up-administrative-data-text-label"}>{t('doctor.Pending_approval')}</label>
                                    <span className={"lineBetween"}/>
                                </div>
                                <div className={"patient-page-up-administrative-data-block"}>
                                    <label className={"patient-page-up-administrative-data-num-label"}>0</label>
                                    <label className={"patient-page-up-administrative-data-text-label"}>{t('doctor.Missed_FU')}
                                    </label>
                                    <span className={"lineBetween"}/>

                                </div>
                                <div className={"patient-page-up-administrative-data-block"}>
                                    <label className={"patient-page-up-administrative-data-num-label"}>0</label>
                                    <label className={"patient-page-up-administrative-data-text-label"}>{t('doctor.reporting_poor')}</label>
                                    <span className={"lineBetween"}/>

                                </div>
                                <div className={"patient-page-up-administrative-data-block"}>
                                    <label className={"patient-page-up-administrative-data-num-label"}>0</label>
                                    <label className={"patient-page-up-administrative-data-text-label"}>{t('doctor.follow_up_is_needed')}</label>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>

                {isSideBarOpen && <AddPatient
                    title={'Edit Admin'}
                    isSideBarOpen={isSideBarOpen}
                    closeSideBar={() => this.setState({isSideBarOpen: false})}/>}
            </>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setPatientsData: patients => dispatch(setPatientsData(patients)),
        filterPatientsTable: patients => dispatch(filterPatientsTable(patients))
    };
}
const mapStateToProps = state => {
    return {
        patientsData:state.patientsTableDataReducer.patientsData,
        initiatePatientsData:state.patientsTableDataReducer.initiatePatientsData
    };
};

const PatientsDashboard = compose(
    withTranslation(),
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
)(PatientsDashboardComposed);
export default PatientsDashboard;
